import { cut } from 'app-core/audio';

export default {
	data() {
		return {
			copyPaste:{ 
				buffer: null,
				track: null,
				options: null,
				isLoading: 0
			}
		}
	},
	mounted() {

	},
	destroyed() {

	},
	methods: {
		async onCopyBuffer(buffer, start, end, options) {
			if (__DEBUG__)
				console.debug('OnCopyBuffer', { start, end });			

			let newBuffer = await cut(buffer, start, end);
			this.copyPaste.buffer = null;
			this.copyPaste.track = options?.track;
			this.copyPaste.options = options;

			this.$nextTick(() => {
				this.copyPaste.buffer = newBuffer;
			});
		},
		async pasteBuffer() {
			if (__DEBUG__)
				console.debug('pasteBuffer');

			this.copyPaste.isLoading++;
			this.$emit('duplicate-track-tool', this.copyPaste.track, {
				StartTime: parseInt(this.currentTime * 1000),
				StartOffset: parseInt(this.copyPaste.options?.startOffset * 1000),
				EndOffset: parseInt(this.copyPaste.options?.endOffset * 1000)
			}, () => {
				this.copyPaste.isLoading--;
			});
		}
	}
};
